<script setup lang="ts">
import { computed } from 'vue'
import { useOnlineStatus } from '../composables/useOnlineStatus'
import { useOfflineSync } from '../composables/useOfflineSync'

const { isOnline, fetchFailed } = useOnlineStatus()
const { pendingCount, isSyncing, lastConflict } = useOfflineSync()

const showBanner = computed(() => !isOnline.value || fetchFailed.value || pendingCount.value > 0)

const bannerText = computed(() => {
  if (!isOnline.value) {
    return pendingCount.value > 0
      ? `离线模式，${pendingCount.value} 个待同步编辑`
      : '离线模式，部分功能受限'
  }
  if (fetchFailed.value) return '网络连接异常，正在重试…'
  if (isSyncing.value) return `正在同步 ${pendingCount.value} 个离线编辑…`
  if (lastConflict.value) return `冲突已解决：${lastConflict.value}`
  if (pendingCount.value > 0) return `${pendingCount.value} 个离线编辑待同步`
  return ''
})

const bannerClass = computed(() => {
  if (!isOnline.value || fetchFailed.value) return 'bg-feedback-warning'
  if (lastConflict.value) return 'bg-feedback-danger'
  return 'bg-feedback-success'
})
</script>

<template>
  <Transition name="slide-down">
    <div
      v-if="showBanner"
      class="fixed top-0 left-0 right-0 z-50 text-white text-center text-sm py-xs px-md"
      :class="bannerClass"
      role="alert"
    >
      {{ bannerText }}
    </div>
  </Transition>
</template>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.2s ease-out;
}
.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
}
</style>
